<a
  (click)="isVisible = !isVisible"
  class="hide-show-password"
  [matRippleCentered]="true"
  matRipple
  aria-hidden="true">
  <mat-icon>{{ isVisible ? 'visibility' : 'visibility_off' }}</mat-icon>
</a>
